import React from "react";
import { Helmet } from "react-helmet";
import { Link } from "react-router-dom";
import { blogData } from "../../blogs";
import BlogCarausel from "./BlogCarausel";
import BlogHelmet from "./BlogHelmet";
import { BlogHeading, BlogImage, BlogLi, BlogList, BlogText, BlogWrapper } from "./blogs.styled";
import TopicNavigation from "./TopicNavigation";

const BlogaccessManagementControlSystemForSME = ({ index }) => {
  return (
    <div className="container" style={{ paddingTop: "9vh" }}>
      <BlogHelmet b={blogData[index]} />
      <BlogWrapper>
        <BlogText style={{ fontWeight: "bold" }}>{blogData[index].date}</BlogText>
        <TopicNavigation index={index} />
        <BlogHeading style={{ color: "rgba(229, 61, 84, 1)" }}>{blogData[index].title}</BlogHeading>
        <BlogText>
          Access management control systems include multiple devices that allow a business to manage
          access to the office building and certain crucial areas of the office. A complete system can
          include technologies like CCTV Camera and access control panel installed with a reader.
          <br />
          Small businesses and startups require this technology to restrict the entry of certain
          employees to sensitive areas of an office, keep track of attendance logs and restrict the entry
          of unnecessary people. In present times, these access management control systems are highly
          beneficial for small businesses to comply with social distancing laws of the government and
          protect their employees against the spread of COVID-19.
          <br />
          For any startup or small business, money and time are the two most crucial assets. Choosing the{" "}
          <Link to="/blog/access-control-system-types">
            {" "}
            right access management control system in
          </Link>{" "}
          the first go is thus very vital to save time and money both. So, here is a quick guide that can
          come handy for startups while making a choice:
        </BlogText>
        <BlogList>
          <BlogLi>
            <strong>Choose A Cloud-Based Technology:</strong> Cloud-based access management control
            system allows management to handle access related activities from any location. For small
            businesses, this centralised dashboard can be more effective and cost-saving.
          </BlogLi>

          <BlogLi>
            <strong>Choose A Company That Offers After and Pre Sales Support:</strong>
            Installation, training, repair, and maintenance can cost a lot of money, time, and efforts to
            a small company or startup. Thus, choosing a company that offers pre and post sales support
            as part of the complete package is advisable.
          </BlogLi>
          <BlogLi>
            <strong>System That Ensures Contactless Entry: </strong>Opting for a system that ensures
            contactless entry is very important in present times. Choosing an access management control
            system that ensures non-biometric, but a card or OTP based entry to staff or visitors is
            highly advised.
          </BlogLi>
          <div className="row">
            <div className="col-md-3 col-sm-12 col-xs-12 col-lg-2"></div>
            <div className="col-md-6 col-sm-12 col-xs-12 col-lg-8">
              <BlogImage src={blogData[index].imgSrc} alt={blogData[index].imgSrcAlt} />
            </div>
            <div className="col-md-3 col-sm-12 col-xs-12 col-lg-2"></div>
          </div>
          <BlogLi>
            <strong>Contactless Temperature Screening:</strong>
            Employing someone to regularly check the temperature of every individual entering or exiting
            the office can cost money and man-power both. Latest technology provides for contactless
            temperature screening, choosing these is advised.
          </BlogLi>
          <BlogLi>
            <strong>Provides Visitor Management System: </strong>Apart from regular employees, small
            businesses or startups can have regular footfall. An{" "}
            <Link to="/blog/choosing-right-office-visitor-management-system">
              in-built visitor management system
            </Link>{" "}
            allows management to record details of individuals coming to meet them, thus ensuring their
            contactless and smooth entry.
          </BlogLi>
          <div className="row">
            <div className="col-md-3 col-sm-12 col-xs-12 col-lg-2"></div>
            <div className="col-md-6 col-sm-12 col-xs-12 col-lg-8">
              <BlogImage src={blogData[index].img2} alt={blogData[index].img2Alt} />
            </div>
            <div className="col-md-3 col-sm-12 col-xs-12 col-lg-2"></div>
          </div>
          <BlogLi>
            <strong>Offers Compliance To Crowd Management Rules: </strong>Access management control
            system also allows management to comply with social distancing norms by ensuring crowd
            management. Such systems restrict the entries inside a building beyond a certain number,
            ensuring the safety of all from the spread of COVID 19 virus.
          </BlogLi>
        </BlogList>
        <BlogText>
          At <Link to="/">SecurePass</Link>, we offer our clients running startups or small businesses
          with cost and time effective access management control systems. Our technology comes built-in
          with a visitor management system that will ensure compliance to all the social distancing rules
          and temperature screening requirements of the visitors. With seamless interface through a
          cloud-based system and end to end support, our access management control system will offer you
          the best alternative for the legacy Biometric, RFID Card, or IRIS Recognition Systems.
          <br />
          Contact us today to get a quote exclusively customised for your business needs!
        </BlogText>
      </BlogWrapper>

      <BlogCarausel prev={blogData[index - 1]} next={blogData[index + 1]} />
    </div>
  );
};

export default BlogaccessManagementControlSystemForSME;
